<fieldset class="border border-gray-300 dark:border-gray-700 rounded-2xl p-4 mb-6">
  <legend [ngClass]="['text-' + legendTextSize, boldLegend ? 'font-semibold' : 'font-normal', 'text-gray-500', 'px-2', 'pb-3']">
    <!-- Si preferís sacar la etiqueta <b> cuando no es bold, podés usar: -->
    @if (boldLegend) {
      <b>{{ title }}</b>
    } @else {
      {{ title }}
    }
  </legend>
  <div [ngClass]="'grid grid-cols-1 md:grid-cols-' + cols + ' gap-4 mb-4'">
    <ng-content></ng-content>
  </div>
</fieldset>
